import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import ProviderProfileService from '@/services/providerProfiles';
import store from '@/store';
import timeSlotUtil from '@/utils/timeSlot';
import randomColor from 'randomcolor';
import moment from 'moment-timezone';
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data: function () {
    return {
      calendarPlugins: [
        // plugins must be defined in the JS
        dayGridPlugin,
        timeGridPlugin,
        listPlugin,
      ],
      calendarWeekends: true,
      calendarEvents: [
        // initial event data
        // {title: 'Event Now', start: new Date()}
      ],
      headers: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
      },
      // timeFormat: 'H(:mm)',
      validRange: {
        start: moment().startOf('month').format(),
        end: moment().add(9, 'week').day('Sunday').utc().format(),
      },
      defaultDate: moment().utc().format(),
      dataSchedule: {},
      views: {
        listWeek: { buttonText: 'list weeks' },
      },
      eventTimeFormat: {
        // like '14:30:00'
        hour: '2-digit',
        minute: '2-digit',
        // second: '2-digit',
        hour12: false,
      },
    };
  },
  computed: {
    user() {
      return store.state.auth.user;
    },
    calendarEvent() {
      return this.calendarEvents;
    },
    appointmentSchedule() {
      return this.$refs.fullCalendar.getApi();
    },
  },
  methods: {
    color() {
      return randomColor({ luminosity: 'dark' });
    },
    toggleWeekends() {
      this.calendarWeekends = !this.calendarWeekends; // update a property
    },
    gotoPast() {
      let calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
      calendarApi.gotoDate('2000-01-01'); // call a method on the Calendar object
    },
    handleDateClick(arg) {
      if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
        this.calendarEvents.push({
          // add new event data
          title: 'New Event',
          start: arg.date,
          allDay: arg.allDay,
        });
      }
    },
    getProviderList() {
      return ProviderProfileService.all().then((data) => {
        data.data.forEach((provider) => {
          provider.schedule = timeSlotUtil.scheduleList(provider, this.user.timezone);
          this.dataSchedule[provider.id] = provider;
        });
        this.providers = data.data;
        // console.log(this.providers);
      });
    },
    setEventForProviderScheduleCalendar(option) {
      const event = [];
      if (!option) {
        this.providers.forEach((provider) => {
          const schedules = provider.schedule;
          for (const key in schedules) {
            // schedule each of provider
            let dates = schedules[key];
            for (let slot in dates) {
              const box = {
                id: provider.id,
                title: `${provider.firstname.en}  ${provider.lastname.en}`,
                start: moment(key + ' ' + dates[slot].startTime).toDate(),
                end: moment(key + ' ' + dates[slot].endTime).toDate(),
                data: dates,
                allDay:
                  moment(key + ' ' + dates[slot].endTime).diff(moment(key + ' ' + dates[slot].startTime), 'hours') == 24
                    ? true
                    : false,
                color: this.color(),
              };
              // console.log(box)
              event.push(box);
            }
          }
        });
      } else {
        option.forEach((id) => {
          //each of provider
          const provider = this.dataSchedule[id];
          const schedules = provider.schedule;
          for (const key in schedules) {
            // schedule each of provider
            let dates = schedules[key];
            for (let slot in dates) {
              const box = {
                id: provider.id,
                title: `${provider.firstname.en}  ${provider.lastname.en}`,
                start: moment(key + ' ' + dates[slot].startTime).toDate(),
                end: moment(key + ' ' + dates[slot].endTime).toDate(),
                data: dates,
                allDay:
                  moment(key + ' ' + dates[slot].endTime).diff(moment(key + ' ' + dates[slot].startTime), 'hours') == 24
                    ? true
                    : false,
                color: this.color(),
              };
              // console.log(box)
              event.push(box);
            }
          }
        });
      }
      console.log(event);
      this.calendarEvents = event.filter(function (range) {
        return moment(range.start).isBefore(moment(range.end)) && moment(range.end).isAfter(moment(range.start));
      });
      // this.appointmentSchedule.refetchEvents()
      // console.log(this.appointmentSchedule.getEventSources())
    },
  },
  mounted() {
    this.getProviderList().then(() => {
      this.setEventForProviderScheduleCalendar();
    });
  },
};
